import { Capacitor } from "@capacitor/core";
import { defineCustomElements } from "@ionic/pwa-elements/loader";
import { PostHogProvider } from "posthog-js/react";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import AccessBlocker from "./AccessBlocker.tsx";
import App from "./App.tsx";
import "./index.css";
import store from "./lib/store.ts";
import reportWebVitals from "./reportWebVitals";

const options = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
};

const root = ReactDOM.createRoot(document.getElementById("root"));

defineCustomElements(root);

let canAccess = false;
if (Capacitor.isNativePlatform()) canAccess = true;
const key = window.localStorage.getItem("canAccess");
if (key && key === "true") canAccess = true;
if (process.env.NODE_ENV === "development") canAccess = true;

// allow access to the app to everyone
canAccess = true;

if (!canAccess) {
  root.render(
    <>
      <React.StrictMode>
        <AccessBlocker />
      </React.StrictMode>
    </>
  );
} else {
  root.render(
    <>
      <React.StrictMode>
        <Provider store={store().store}>
          <PersistGate loading={null} persistor={store().persistor}>
            <PostHogProvider
              apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
              options={options}
            >
              <App />
            </PostHogProvider>
          </PersistGate>
        </Provider>
      </React.StrictMode>
    </>
  );

  reportWebVitals();
}
